export const optionTitle_messageHeight = "$kd";
export const optionTitle_textSizeSpacing = "ald";
export default {optionTitle_messageHeight,optionTitle_textSizeSpacing};